import { keyframes } from '@/features/shared/styles/effects/keyframes'

export const fadeIn = `${keyframes.fade} 0.6s ease-in-out`

export const fadeIn2 = `${keyframes.fade} 1s ease-in-out`

const visibilityTransition = `opacity 0.2s ease-in-out`

export const hide = `
  visibility: hidden;
  opacity: 0;
  transition: visibility 0.2s, ${visibilityTransition};
`
